<template>
  <div>
    <TransitionGroup
      name="toast"
      tag="div"
      class="v-toast-notification"
    >
      <div
        v-for="toast in toastMessages"
        :key="toast.id"
        class="v-toast-notification__item"
        :class="{ 'x-error': toast.message.type === 'error', 'x-warning': toast.message.type === 'warning', 'x-info': toast.message.type === 'info' }"
      >
        <div class="v-toast-notification__item__content">
          {{ toast.message.msg }}
        </div>

        <button
          aria-label="Schließen"
          @click="dismissToast(toast.id)"
        >
          ×
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useMessages } from '@/composables/useMessages';

const { toastMessages, dismissToast } = useMessages()
</script>
